import React from "react";
import { connect } from "react-redux";
import { goTo } from "../tools";

import GnpVideosMenu from "./gnp-videos-menu.cmpt";
import GnpVideosDetalle from "./gnp-videos-detalle.cmpt";
import GnpVideos from "./gnp-videos.cmpt";

const mapState = (state) => {
	return {};
	// return {
	//     loading: state.global.loading,
	//     detalle: state.videos.detalle
	// }
};

const mapDispatch = (dispatch) => {
	return {};
	// return {
	//     alerta: (sTitulo, sMensaje, fnCerrar) => {
	// 	dispatch({ "type": "MODAL_ALERT_MESSAGES_ACTION_SHOW", "titulo": sTitulo, "mensaje": sMensaje, "accion": fnCerrar });
	// }
	// }
};

class Flujo extends React.Component {
	state = {
		"chosenVid": 0,
		"showDetalle": false,
	}
	componentWillMount() {
		if (this.props.videoID) {
			console.log("trae ID");
			this.setState({
				chosenVid: this.props.videoID,
				showDetalle: true
			});
		}else {
			console.log("NO trae ID");
			this.setState({
				chosenVid: 0,
				showDetalle: false
			});
		}
	}

	toggle = (id) => {
		$("video").each(function () { this.pause() });
		if (id) {
			this.setState({
				chosenVid: id,
				showDetalle: true
			});
		}
		else {
			this.setState({
				chosenVid: 0,
				showDetalle: false
			});
		}
	}

	render() {
		return (
			<div className="flex layout-row layout-xs-column layout-align-start-stretch layout-padding" style={{"maxWidth":"1250px","margin":"0px auto"}}>
				<GnpVideosMenu toggle={this.toggle} chosenVid={this.state.chosenVid} showDetalle={this.state.showDetalle} toggle={this.toggle}/>
				{ !this.state.showDetalle &&
					<GnpVideos  toggle={this.toggle}/>
				}
				{ this.state.showDetalle &&
					<GnpVideosDetalle chosenVid={this.state.chosenVid}/>
				}
			</div>
		);
	};
}

export default connect(mapState, mapDispatch)(Flujo);

/*<div className="gnp-generales">
	<div className="gnp-servicios">
		<div className="btn-group-vertical" role="group" aria-label="...">
			<div className="btn-group" role="group">
				<button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
					Apoyos para trámites y siniestros
					<span className="caret"></span>
				</button>
				<ul className="dropdown-menu">
					<li><a href="#">Dropdown link</a></li>
					<li><a href="#">Dropdown link</a></li>
				</ul>
			</div>
			<button type="button" className="btn btn-default">Tips para Contraseñas Seguras</button>
			<button type="button" className="btn btn-default">Revista Viviendo GNP</button>
			<button type="button" className="btn btn-default">Unidad Especializada de Atención a Usuario</button>
		</div>
	</div>
</div>*/



// WEBPACK FOOTER //
// ./src/gnp-servicios/flujo.cmpt.js